import { createFileRoute } from "@tanstack/react-router";

import { PrincipalsPanel } from "../../../../workspaces/settings/platform/PrincipalsPanel";

export const Route = createFileRoute("/_console/settings/platform/principals")({
  component: PrincipalsPanel,
});
